import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BottomDrawer from '../../components/common/BottomDrawer';
import { InputBackOffice } from '../../components/common/InputBackoffice';
import Spinner from '../../components/common/Spinner';
import { ErrorToast } from '../../components/common/Toasts/Toasts';
import check from '../../assets/icons/check.svg';
import search from '../../assets/icons/search.svg';
import { P2, P3 } from '../../styles/FontStyles';
import {
  ArrowPolygon,
  AuthLayoutSubTitle,
  AuthLayoutTitle,
  Flexed,
  Select,
  ToggleTabButton,
  ToggleTabs
} from '../../styles/GlobalComponents';
import {
  FlexCenter,
  Label,
  SInput,
  SInputContainer
} from '../../styles/stylesStyled';
import { CreationTypes } from '../../types/loginTypes';
import { RouteComponentProps } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Button } from '../../components';
import countries from '../../lib/countries';
import { colors } from '../../styles/GlobalStyles';
import {
  updateProfileDetails,
  updateSocialProfileDetails
} from './ProfileDetails.actions';

const ProfileDetails = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation('onboarding');

  const dispatch = useAppDispatch();

  const { loading, register } = useAppSelector((state) => state.auth);

  const { user, referrer, token } = register;

  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [surname, setSurname] = useState('');
  const [genderType, setGenderType] = useState(1);
  const [address, setAddress] = useState('');
  const [city, setCity] = useState('');
  const [postal, setPostal] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [country, setCountry] = useState('');
  const [userCountry] = useState('');
  const [countryCode, setCountryCode] = useState('');

  const [countryList, setCountryList] = useState(countries);
  const [countryImage, setCountryImage] = useState('');

  const [selectedTab, setSelectedTab] = useState('male');

  const [isVisible, setIsVisible] = useState(false);

  const letterUpercaseAndSpace = /^[a-zA-Z\s]*$/;

  const onClose = useCallback(() => {
    setIsVisible(false);
  }, []);

  const selectTab = (tab: string) => {
    setSelectedTab(tab);
    if (tab === 'male') {
      setGenderType(1);
    } else if (tab === 'female') {
      setGenderType(2);
    } else {
      setGenderType(3);
    }
  };

  const confirm = () => {
    if (!name) {
      ErrorToast(t('profile_details.err_please_add_name'));
    } else if (!surname) {
      ErrorToast(t('profile_details.err_please_add_lastname'));
    } else if (!username) {
      ErrorToast(t('profile_details.err_please_add_username'));
    } else if (!address) {
      ErrorToast(t('profile_details.err_please_add_address'));
    } else if (!postal) {
      ErrorToast(t('profile_details.err_please_add_postal_code'));
    } else if (!city) {
      ErrorToast(t('profile_details.err_please_add_city'));
    } else {
      if (user.creationType === CreationTypes.Local) {
        dispatch(
          updateProfileDetails({
            userId: user.id,
            name,
            surname,
            username,
            genderType,
            address,
            zipCode: postal,
            city,
            country,
            countryCode,
            history
          })
        );
      } else {
        dispatch(
          updateSocialProfileDetails({
            token,
            name,
            surname,
            username,
            genderType,
            address,
            zipCode: postal,
            city,
            country,
            countryCode,
            history
          })
        );
      }
    }
  };

  const checkFirstName = (e: string) => {
    if (e.match(letterUpercaseAndSpace)) {
      setName(
        e
          .replace(/|[0-9]/g, '')
          .toLowerCase()
          .split('profile_details. ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      );
    } else {
      return;
    }
  };

  const checkLastName = (e: string) => {
    if (e.match(letterUpercaseAndSpace)) {
      setSurname(
        e
          .replace(/|[0-9]/g, '')
          .toLowerCase()
          .split('profile_details. ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      );
    } else {
      return;
    }
  };

  const checkCountry = (country: any) => {
    setCountryList(
      countryList.map((item) =>
        item.name === country.name
          ? {
              ...item,
              checked: true
            }
          : {
              ...item,
              checked: false
            }
      )
    );
  };

  useEffect(() => {
    setName(user?.name);
    setSurname(user?.surname);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Required = () => {
    return <span style={{ color: colors.primary900 }}>*</span>;
  };

  const showReferrer = () => {
    if (referrer?.name) {
      if (referrer?.name === 'Matjaz' && referrer?.surname === 'Torč') {
        return <></>;
      } else {
        return (
          <P3 bold center color={colors.primary900} mb='20'>
            Referred by {referrer?.name} {referrer?.surname}
          </P3>
        );
      }
    } else {
      return (
        <P3 bold center color={colors.primary900} mb='20'>
          Referred by {user?.referrerId}
        </P3>
      );
    }
  };

  return (
    <>
      {loading && <Spinner fullScreen={true} transparent />}

      <AuthLayoutTitle>Join the Freelauch</AuthLayoutTitle>
      <AuthLayoutSubTitle>Become a United One Partner</AuthLayoutSubTitle>

      <Flexed center justifyCenter m='20px 0' style={{ scale: '0.9' }}>
        <ProgressSvg />
      </Flexed>

      {/* {referrer?.name !== 'Matjaz' && referrer?.surname !== 'Torč' && ( */}

      {showReferrer()}
      {/* )} */}

      {/* <Label>
        {t('profile_details.select_your_gender')} <Required />
      </Label> */}

      <ToggleTabs>
        <ToggleTabButton
          selected={selectedTab === 'male'}
          onClick={() => selectTab('male')}>
          {t('profile_details.male')}
        </ToggleTabButton>
        <ToggleTabButton
          selected={selectedTab === 'female'}
          onClick={() => selectTab('female')}>
          {t('profile_details.female')}
        </ToggleTabButton>
        <ToggleTabButton
          selected={selectedTab === 'other'}
          onClick={() => selectTab('other')}>
          {t('profile_details.other')}
        </ToggleTabButton>
      </ToggleTabs>

      <Label>
        {t('profile_details.usernameLabel')}
        <Required />
      </Label>

      <InputBackOffice
        id={'username'}
        type={'text'}
        placeholder={t('profile_details.usernamePlaceholder')}
        name={'username'}
        value={username.replace(/[^A-Z0-9]/gi, '') || ''}
        onChange={(e: string) =>
          setUsername(e.replace(/[^A-Z0-9]/gi, '').toLowerCase())
        }
        label={t('profile_details.usernameLabel')}
      />

      <Label>
        {t('profile_details.firstAndLastName')}
        <Required />
      </Label>

      <InputBackOffice
        id={'firstName'}
        type={'text'}
        placeholder={t('profile_details.firstNamePlaceholder')}
        name={'name'}
        value={name}
        onChange={(e: string) => checkFirstName(e)}
        label={t('profile_details.firstNameLabel')}
        maxlength='16'
      />

      <InputBackOffice
        id={'surname'}
        type={'text'}
        placeholder={t('profile_details.lastNamePlaceholder')}
        name={'surname'}
        value={surname}
        onChange={(e: string) => checkLastName(e)}
        label={t('profile_details.lastNameLabel')}
        maxlength='16'
      />

      <Label>
        {t('profile_details.address')}
        <Required />
      </Label>
      <InputBackOffice
        id={'address'}
        type={'text'}
        placeholder={t('profile_details.streetAddressPlaceholder')}
        name={'address'}
        value={address || ''}
        onChange={setAddress}
        label={t('profile_details.streetAddressLabel')}
      />

      <InputBackOffice
        id={'postal'}
        type={'text'}
        placeholder={t('profile_details.postalCodePlaceholder')}
        name={'postal'}
        value={postal || ''}
        onChange={setPostal}
        label={t('profile_details.postalCodeLabel')}
      />

      <InputBackOffice
        id={'city'}
        type={'text'}
        placeholder={t('profile_details.cityPlaceholder')}
        name={'city'}
        value={city || ''}
        onChange={setCity}
        label={t('profile_details.cityLabel')}
      />

      <div>
        <Label>
          Country <Required />
        </Label>

        <Select
          onClick={() => {
            setIsVisible(true);
          }}
          style={{ cursor: 'pointer' }}>
          <FlexCenter>
            {countryImage && (
              <img
                src={countryImage}
                alt='flag'
                style={{
                  marginRight: '20px',
                  width: '28px',
                  height: '20px'
                }}
              />
            )}

            <div>{country || t('profile_details.countryLabel')}</div>
          </FlexCenter>
          <ArrowPolygon direction={''} />
        </Select>
      </div>

      <Button
        negative
        m='30px 0 10px 0'
        disabled={
          name === '' ||
          username === '' ||
          surname === '' ||
          address === '' ||
          postal === '' ||
          city === ''
        }
        onClick={confirm}>
        {t('profile_details.continue')}
      </Button>

      <BottomDrawer isVisible={isVisible} onClose={onClose} height={'90vh'}>
        <SInputContainer>
          <img src={search} alt='search.svg' />
          <SInput
            placeholder={t('profile_details.countryLabelPlaceholder')}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </SInputContainer>
        {countryList &&
          countryList
            ?.sort((a) => (a.name === userCountry ? -1 : 1))
            .filter((value) => {
              if (searchTerm === '') {
                return value;
              } else if (
                value.name.toLowerCase().includes(searchTerm.toLowerCase())
              ) {
                return value;
              } else return null;
            })
            .map((country, i) => {
              if (country.hidden) return null;
              return (
                <div
                  onClick={() => {
                    setCountry(country.name);
                    setCountryCode(country.code);
                    setCountryImage(country.flag);
                    setIsVisible(false);
                    checkCountry(country);
                  }}
                  key={i}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: 'pointer'
                  }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginBottom: '20px'
                    }}>
                    <img
                      src={country.flag}
                      alt='flag'
                      style={{
                        marginRight: '20px',
                        width: '28px',
                        height: '20px'
                      }}
                    />

                    <P2>{country.name}</P2>
                  </div>
                  {country.checked && (
                    <img
                      src={check}
                      alt='check'
                      style={{ marginBottom: '30px' }}
                    />
                  )}
                </div>
              );
            })}
      </BottomDrawer>
    </>
  );
};

export default ProfileDetails;

const ProgressSvg = () => (
  <svg
    width='400'
    height='45'
    viewBox='0 0 400 45'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <rect x='18' width='45' height='45' rx='22.5' fill='#AE8E66' />
    <path
      d='M40.5 20.5C42.7091 20.5 44.5 18.7091 44.5 16.5C44.5 14.2909 42.7091 12.5 40.5 12.5C38.2909 12.5 36.5 14.2909 36.5 16.5C36.5 18.7091 38.2909 20.5 40.5 20.5Z'
      stroke='white'
      strokeWidth='1.5'
    />
    <path
      d='M48.5 28C48.5 30.485 48.5 32.5 40.5 32.5C32.5 32.5 32.5 30.485 32.5 28C32.5 25.515 36.082 23.5 40.5 23.5C44.918 23.5 48.5 25.515 48.5 28Z'
      stroke='white'
      strokeWidth='1.5'
    />
    <path
      d='M68.2373 27.5V17.6357H69.7686V27.5H68.2373ZM72.0723 27.5V20.0762H73.5557V21.2041H73.665C74.0273 20.4111 74.7383 19.9326 75.8184 19.9326C77.4795 19.9326 78.3955 20.9238 78.3955 22.6943V27.5H76.9189V23.043C76.9189 21.8125 76.4062 21.2041 75.3193 21.2041C74.2324 21.2041 73.5557 21.9492 73.5557 23.1455V27.5H72.0723ZM80.9932 27.5V21.2451H79.7695V20.0762H80.9932V19.2969C80.9932 17.8203 81.7383 17.0957 83.29 17.0957C83.6182 17.0957 83.9053 17.1162 84.165 17.1641V18.251C84.0283 18.2305 83.8301 18.2168 83.5977 18.2168C82.7773 18.2168 82.4561 18.6133 82.4561 19.3652V20.0762H84.1035V21.2451H82.4697V27.5H80.9932ZM88.6289 27.6436C86.4482 27.6436 85.1152 26.1875 85.1152 23.7949V23.7812C85.1152 21.3955 86.4551 19.9326 88.6289 19.9326C90.7959 19.9326 92.1357 21.3887 92.1357 23.7812V23.7949C92.1357 26.1875 90.8027 27.6436 88.6289 27.6436ZM88.6289 26.4062C89.9004 26.4062 90.625 25.4355 90.625 23.7949V23.7812C90.625 22.1338 89.9004 21.1699 88.6289 21.1699C87.3506 21.1699 86.6328 22.1338 86.6328 23.7812V23.7949C86.6328 25.4424 87.3506 26.4062 88.6289 26.4062ZM93.9062 27.5V20.0762H95.3896V21.1973H95.499C95.7656 20.4111 96.4561 19.9463 97.4473 19.9463C97.6865 19.9463 97.9463 19.9805 98.0967 20.0146V21.3818C97.8301 21.3271 97.5771 21.293 97.2969 21.293C96.1621 21.293 95.3896 21.9902 95.3896 23.0635V27.5H93.9062ZM99.6211 27.5V20.0762H101.104V21.2178H101.214C101.542 20.4043 102.267 19.9326 103.237 19.9326C104.249 19.9326 104.967 20.459 105.295 21.2588H105.411C105.787 20.459 106.642 19.9326 107.674 19.9326C109.171 19.9326 110.046 20.835 110.046 22.3799V27.5H108.569V22.7354C108.569 21.71 108.104 21.2041 107.134 21.2041C106.19 21.2041 105.568 21.9082 105.568 22.8037V27.5H104.092V22.585C104.092 21.7373 103.538 21.2041 102.663 21.2041C101.768 21.2041 101.104 21.9697 101.104 22.9404V27.5H99.6211ZM114.154 27.623C112.739 27.623 111.693 26.7617 111.693 25.415V25.4014C111.693 24.0752 112.691 23.3027 114.462 23.1934L116.472 23.0771V22.4209C116.472 21.6074 115.959 21.1562 114.954 21.1562C114.134 21.1562 113.594 21.457 113.416 21.9834L113.409 22.0107H111.98L111.987 21.9629C112.165 20.7461 113.334 19.9326 115.022 19.9326C116.889 19.9326 117.941 20.8623 117.941 22.4209V27.5H116.472V26.4473H116.355C115.918 27.1992 115.139 27.623 114.154 27.623ZM113.17 25.3535C113.17 26.0371 113.751 26.4404 114.551 26.4404C115.658 26.4404 116.472 25.7158 116.472 24.7588V24.123L114.66 24.2393C113.635 24.3008 113.17 24.6699 113.17 25.3398V25.3535ZM122.836 27.5479C121.202 27.5479 120.532 26.9736 120.532 25.5449V21.2451H119.37V20.0762H120.532V18.2031H122.043V20.0762H123.636V21.2451H122.043V25.1895C122.043 25.9893 122.344 26.3174 123.075 26.3174C123.301 26.3174 123.431 26.3105 123.636 26.29V27.4727C123.396 27.5137 123.123 27.5479 122.836 27.5479ZM126.138 18.75C125.625 18.75 125.208 18.333 125.208 17.8271C125.208 17.3145 125.625 16.8975 126.138 16.8975C126.644 16.8975 127.067 17.3145 127.067 17.8271C127.067 18.333 126.644 18.75 126.138 18.75ZM125.393 27.5V20.0762H126.869V27.5H125.393ZM132.174 27.6436C129.993 27.6436 128.66 26.1875 128.66 23.7949V23.7812C128.66 21.3955 130 19.9326 132.174 19.9326C134.341 19.9326 135.681 21.3887 135.681 23.7812V23.7949C135.681 26.1875 134.348 27.6436 132.174 27.6436ZM132.174 26.4062C133.445 26.4062 134.17 25.4355 134.17 23.7949V23.7812C134.17 22.1338 133.445 21.1699 132.174 21.1699C130.896 21.1699 130.178 22.1338 130.178 23.7812V23.7949C130.178 25.4424 130.896 26.4062 132.174 26.4062ZM137.451 27.5V20.0762H138.935V21.2041H139.044C139.406 20.4111 140.117 19.9326 141.197 19.9326C142.858 19.9326 143.774 20.9238 143.774 22.6943V27.5H142.298V23.043C142.298 21.8125 141.785 21.2041 140.698 21.2041C139.611 21.2041 138.935 21.9492 138.935 23.1455V27.5H137.451Z'
      fill='#373737'
    />
    <path d='M169 22.5H249' stroke='#AE8E66' />
    <rect x='257' width='45' height='45' rx='22.5' fill='#A4A4A4' />
    <path
      d='M272.58 20.1206H286.42C286.545 20.1205 286.669 20.1451 286.784 20.1928C286.899 20.2405 287.004 20.3105 287.092 20.3987C287.181 20.4869 287.251 20.5916 287.299 20.7069C287.346 20.8222 287.371 20.9458 287.371 21.0706V31.3001C287.371 31.5521 287.271 31.7937 287.093 31.9719C286.914 32.15 286.673 32.2501 286.421 32.2501H272.58C272.456 32.2502 272.332 32.2256 272.217 32.1779C272.101 32.1302 271.997 32.0603 271.908 31.972C271.82 31.8838 271.75 31.7791 271.702 31.6638C271.654 31.5485 271.63 31.4249 271.63 31.3001V21.0711C271.63 20.8192 271.73 20.5775 271.908 20.3994C272.086 20.2212 272.328 20.1211 272.58 20.1211'
      stroke='white'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M274.291 20.1205V17.939C274.3 15.064 276.637 12.741 279.512 12.75C282.374 12.759 284.692 15.077 284.701 17.939V20.1205'
      stroke='white'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M311.237 15.5V5.63574H312.769V14.1807H317.39V15.5H311.237ZM321.936 15.6436C319.762 15.6436 318.449 14.1602 318.449 11.8086V11.8018C318.449 9.48438 319.789 7.93262 321.86 7.93262C323.932 7.93262 325.203 9.42969 325.203 11.6582V12.1777H319.939C319.967 13.5996 320.746 14.4268 321.97 14.4268C322.92 14.4268 323.487 13.9551 323.665 13.5723L323.692 13.5176L325.121 13.5107L325.107 13.5723C324.861 14.5498 323.836 15.6436 321.936 15.6436ZM321.867 9.14941C320.855 9.14941 320.09 9.83984 319.96 11.1182H323.733C323.617 9.79199 322.872 9.14941 321.867 9.14941ZM330.104 18.1182C328.218 18.1182 327.056 17.291 326.878 16.0537L326.892 16.04H328.389L328.396 16.0537C328.519 16.5664 329.12 16.9287 330.125 16.9287C331.349 16.9287 332.073 16.3545 332.073 15.3428V13.8799H331.964C331.513 14.6865 330.692 15.1377 329.674 15.1377C327.767 15.1377 326.591 13.668 326.591 11.5762V11.5625C326.591 9.44336 327.773 7.94629 329.701 7.94629C330.74 7.94629 331.547 8.45898 331.978 9.29297H332.066V8.07617H333.543V15.3496C333.543 17.0381 332.21 18.1182 330.104 18.1182ZM330.084 13.9141C331.342 13.9141 332.101 12.957 332.101 11.5693V11.5557C332.101 10.1748 331.335 9.2041 330.084 9.2041C328.819 9.2041 328.108 10.1748 328.108 11.5557V11.5693C328.108 12.9502 328.819 13.9141 330.084 13.9141ZM337.713 15.623C336.298 15.623 335.252 14.7617 335.252 13.415V13.4014C335.252 12.0752 336.25 11.3027 338.021 11.1934L340.03 11.0771V10.4209C340.03 9.60742 339.518 9.15625 338.513 9.15625C337.692 9.15625 337.152 9.45703 336.975 9.9834L336.968 10.0107H335.539L335.546 9.96289C335.724 8.74609 336.893 7.93262 338.581 7.93262C340.447 7.93262 341.5 8.8623 341.5 10.4209V15.5H340.03V14.4473H339.914C339.477 15.1992 338.697 15.623 337.713 15.623ZM336.729 13.3535C336.729 14.0371 337.31 14.4404 338.109 14.4404C339.217 14.4404 340.03 13.7158 340.03 12.7588V12.123L338.219 12.2393C337.193 12.3008 336.729 12.6699 336.729 13.3398V13.3535ZM343.66 15.5V5.16406H345.144V15.5H343.66ZM354.256 15.6846C352.246 15.6846 350.879 14.5498 350.879 12.8955V12.8818C350.879 11.6992 351.501 10.8242 352.813 10.1611L353.203 9.96289C352.273 8.93066 351.959 8.34961 351.959 7.67969V7.66602C351.959 6.37402 353.08 5.43066 354.584 5.43066C356.095 5.43066 357.188 6.36035 357.188 7.65918V7.67285C357.188 8.64355 356.614 9.40234 355.09 10.2295L357.318 12.5947C357.633 11.918 357.783 11.1113 357.783 10.2295V10.0039H359.116V10.2842C359.116 11.5693 358.85 12.7109 358.289 13.6201L360.053 15.4932V15.5H358.262L357.448 14.6113C356.662 15.2881 355.603 15.6846 354.256 15.6846ZM353.333 7.74121C353.333 8.22656 353.586 8.61621 354.352 9.43652C355.479 8.8418 355.849 8.37012 355.849 7.74121V7.72754C355.849 7.03027 355.336 6.53125 354.591 6.53125C353.859 6.53125 353.333 7.03027 353.333 7.72754V7.74121ZM352.342 12.7793C352.342 13.8047 353.169 14.4951 354.399 14.4951C355.322 14.4951 356.047 14.1875 356.58 13.6611L353.976 10.8105L353.661 10.9678C352.8 11.3916 352.342 12.0137 352.342 12.7656V12.7793ZM315.284 39.7393C312.543 39.7393 310.834 37.7568 310.834 34.5781V34.5645C310.834 31.3789 312.536 29.3965 315.277 29.3965C317.451 29.3965 319.119 30.7705 319.379 32.7324L319.372 32.7666H317.854V32.7461C317.567 31.5361 316.576 30.75 315.277 30.75C313.507 30.75 312.399 32.2197 312.399 34.5645V34.5781C312.399 36.916 313.507 38.3857 315.284 38.3857C316.59 38.3857 317.567 37.6885 317.848 36.5742L317.861 36.5469H319.379V36.5879C319.092 38.4814 317.485 39.7393 315.284 39.7393ZM324.369 39.6436C322.188 39.6436 320.855 38.1875 320.855 35.7949V35.7812C320.855 33.3955 322.195 31.9326 324.369 31.9326C326.536 31.9326 327.876 33.3887 327.876 35.7812V35.7949C327.876 38.1875 326.543 39.6436 324.369 39.6436ZM324.369 38.4062C325.641 38.4062 326.365 37.4355 326.365 35.7949V35.7812C326.365 34.1338 325.641 33.1699 324.369 33.1699C323.091 33.1699 322.373 34.1338 322.373 35.7812V35.7949C322.373 37.4424 323.091 38.4062 324.369 38.4062ZM329.646 39.5V32.0762H331.13V33.2178H331.239C331.567 32.4043 332.292 31.9326 333.263 31.9326C334.274 31.9326 334.992 32.459 335.32 33.2588H335.437C335.812 32.459 336.667 31.9326 337.699 31.9326C339.196 31.9326 340.071 32.835 340.071 34.3799V39.5H338.595V34.7354C338.595 33.71 338.13 33.2041 337.159 33.2041C336.216 33.2041 335.594 33.9082 335.594 34.8037V39.5H334.117V34.585C334.117 33.7373 333.563 33.2041 332.688 33.2041C331.793 33.2041 331.13 33.9697 331.13 34.9404V39.5H329.646ZM342.143 41.9746V32.0762H343.626V33.2451H343.735C344.166 32.4316 344.979 31.9463 346.019 31.9463C347.892 31.9463 349.095 33.4434 349.095 35.7812V35.7949C349.095 38.1465 347.905 39.623 346.019 39.623C345 39.623 344.132 39.124 343.735 38.3242H343.626V41.9746H342.143ZM345.602 38.3584C346.839 38.3584 347.584 37.3877 347.584 35.7949V35.7812C347.584 34.1816 346.839 33.2178 345.602 33.2178C344.364 33.2178 343.599 34.1953 343.599 35.7812V35.7949C343.599 37.3809 344.364 38.3584 345.602 38.3584ZM350.947 39.5V29.1641H352.431V39.5H350.947ZM355.411 30.75C354.898 30.75 354.481 30.333 354.481 29.8271C354.481 29.3145 354.898 28.8975 355.411 28.8975C355.917 28.8975 356.341 29.3145 356.341 29.8271C356.341 30.333 355.917 30.75 355.411 30.75ZM354.666 39.5V32.0762H356.143V39.5H354.666ZM360.34 39.623C358.925 39.623 357.879 38.7617 357.879 37.415V37.4014C357.879 36.0752 358.877 35.3027 360.647 35.1934L362.657 35.0771V34.4209C362.657 33.6074 362.145 33.1562 361.14 33.1562C360.319 33.1562 359.779 33.457 359.602 33.9834L359.595 34.0107H358.166L358.173 33.9629C358.351 32.7461 359.52 31.9326 361.208 31.9326C363.074 31.9326 364.127 32.8623 364.127 34.4209V39.5H362.657V38.4473H362.541C362.104 39.1992 361.324 39.623 360.34 39.623ZM359.355 37.3535C359.355 38.0371 359.937 38.4404 360.736 38.4404C361.844 38.4404 362.657 37.7158 362.657 36.7588V36.123L360.846 36.2393C359.82 36.3008 359.355 36.6699 359.355 37.3398V37.3535ZM366.219 39.5V32.0762H367.702V33.2041H367.812C368.174 32.4111 368.885 31.9326 369.965 31.9326C371.626 31.9326 372.542 32.9238 372.542 34.6943V39.5H371.065V35.043C371.065 33.8125 370.553 33.2041 369.466 33.2041C368.379 33.2041 367.702 33.9492 367.702 35.1455V39.5H366.219ZM377.737 39.6436C375.57 39.6436 374.244 38.167 374.244 35.7676V35.7539C374.244 33.4023 375.563 31.9326 377.73 31.9326C379.597 31.9326 380.711 32.9854 380.916 34.4277V34.4619L379.494 34.4688L379.487 34.4482C379.323 33.7168 378.722 33.1699 377.737 33.1699C376.5 33.1699 375.755 34.1543 375.755 35.7539V35.7676C375.755 37.4082 376.514 38.4062 377.737 38.4062C378.667 38.4062 379.241 37.9824 379.48 37.1826L379.494 37.1484H380.916L380.902 37.21C380.636 38.6523 379.576 39.6436 377.737 39.6436ZM385.715 39.6436C383.541 39.6436 382.229 38.1602 382.229 35.8086V35.8018C382.229 33.4844 383.568 31.9326 385.64 31.9326C387.711 31.9326 388.982 33.4297 388.982 35.6582V36.1777H383.719C383.746 37.5996 384.525 38.4268 385.749 38.4268C386.699 38.4268 387.267 37.9551 387.444 37.5723L387.472 37.5176L388.9 37.5107L388.887 37.5723C388.641 38.5498 387.615 39.6436 385.715 39.6436ZM385.646 33.1494C384.635 33.1494 383.869 33.8398 383.739 35.1182H387.513C387.396 33.792 386.651 33.1494 385.646 33.1494Z'
      fill='#858585'
    />
  </svg>
);
